import type { IState } from '@/interfaces'

export class State implements IState {
	code: string
	name: string
	country: string
	constructor({ code, name, country }: IState) {
		this.code = code
		this.name = name
		this.country = country
	}
}
